  /* eslint-disable array-callback-return */
  /* eslint-disable react-hooks/exhaustive-deps */
  import {
    setBackButtonPath,
  // TOAST_MESSAGE_SEVERITY_ERROR,
  setPageTitle,
  showToast,
  TOAST_MESSAGE_SEVERITY_SUCCESS,
} from '../../layout/layout.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { Box, Checkbox, FormControlLabel, Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import GooglePlacesAutocompleteComponent from 'common/form/googlePlacesAutocomplete.component';
import BenefitSelections from '../benefitSelections.component';
import { getDistance } from 'utilities/googleMapsClient';
import { GET_POLICIES_SUCCESS, getAutoShipmentCost, getFlightPrice, getHomesalePriceByRegion, getPolicies, postPolicy, updatePolicy } from '../estimator.actions';
import { getGsaPerDiem, getNationalGsaLodgingPerDiem, getNationalGsaMealPerDiem } from '../estimatorDataRequests';
import { getBenefits } from '../constants';
import { getSelectedClientInformation } from 'utilities/authUtils';
import NavigationPrompt from 'react-router-navigation-prompt';
import ConfirmModal from 'common/confirmModal.component';

const useStyles = makeStyles((theme) => ({
  textField: {
     width: '200px',
  },
}));

const PolicyEditorPage = (props) => {  
  const policyId = props.match.params.policyId ? parseInt(props.match.params.policyId) : null;
  const policyInfo = policyId ? props.policies.find((e) => e.policyId === policyId) : null;

  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [policyName, setPolicyName] = useState(policyInfo ? policyInfo.policyName : null);
  const [isPublished, setIsPublished] = useState(policyInfo ? policyInfo.isPublished : false);
  const [distance, setDistance] = useState(0);

  const [benefits, setBenefits] = useState([]);

  const [perDiemRate, setPerDiemRate] = useState(0);
  const [perDiemMealRate, setPerDiemMealRate] = useState(0);
  const [avgHomesalePrice, setAvgHomesalePrice] = useState(0);
  const [avgHomesalePriceOrigin, setAvgHomesalePriceOrigin] = useState(0);
  const [flightCost, setFlightCost] = useState(0);
  const [isUpdatingSelections, setIsUpdatingSelections] = useState(false);
  const [homefindingDays, setHomefindingDays] = useState(3);
  const [autoShipmentCost, setAutoShipmentCost] = useState(0);

  const [savingPolicy, setSavingPolicy] = useState(false);
  const [updatedPolicyBenefits, setUpdatedPolicyBenefits] = useState(null);

  const [isDirty, setIsDirty] = useState(false);
  const [isBenefitListDirty, setIsBenefitListDirty] = useState(false);

  const clientId = getSelectedClientInformation().id;

  const classes = useStyles();

  const savePolicy = async (savedBenefits, applyTaxGrossUp, grossUpPercentage, isSettingPolicyOrOwnershipType, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine) => {
      setSavingPolicy(true);

      let policyBody = {
          policyId: policyId,
          clientId: clientId,
          policyName: policyName,
          isPublished: isPublished,
          createdDate: policyInfo.createdDate,
          savedBenefits: savedBenefits,
          applyTaxGrossUp: applyTaxGrossUp,
          grossUpPercentage: grossUpPercentage,
          topLevelInputOneId: topLevelInputOneId ? topLevelInputOneId : (policyInfo ? policyInfo.topLevelInputOneId : null),
          topLevelInputTwoId: topLevelInputTwoId ? topLevelInputTwoId : (policyInfo ? policyInfo.topLevelInputTwoId : null),
          topLevelInputThreeId: topLevelInputThreeId ? topLevelInputThreeId : (policyInfo ? policyInfo.topLevelInputThreeId : null),
          topLevelInputFourId: topLevelInputFourId ? topLevelInputFourId : (policyInfo ? policyInfo.topLevelInputFourId : null),
          topLevelInputFive: topLevelInputFive ? topLevelInputFive : (policyInfo ? policyInfo.topLevelInputFive : null),
          topLevelInputSix: topLevelInputSix ? topLevelInputSix : (policyInfo ? policyInfo.topLevelInputSix : null),
          topLevelInputSeven: topLevelInputSeven ? topLevelInputSeven : (policyInfo ? policyInfo.topLevelInputSeven : null),
          topLevelInputEight: topLevelInputEight ? topLevelInputEight : (policyInfo ? policyInfo.topLevelInputEight : null),
          topLevelInputNine: topLevelInputNine ? topLevelInputNine : (policyInfo ? policyInfo.topLevelInputNine : null),
      }

      const updatePolicyResp = await props.updatePolicy(policyBody);
      if (updatePolicyResp.response) {
          const getPoliciesResp = await props.getPolicies();
          if (getPoliciesResp.type === GET_POLICIES_SUCCESS) {
              setBenefits(getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance));
              
              // Update the policy benefits to sync with BenefitSelections component
              const updatedPolicy = getPoliciesResp.response.find((p) => p.policyId === policyId);
              if (updatedPolicy) {
                // Deduplicate custom benefit options when receiving from backend
                const cleanedBenefits = updatedPolicy.savedBenefits.map(benefit => {
                  if (benefit.benefitNumber === 9 && benefit.options) {
                    // Deduplicate options for Additional Benefits
                    const deduplicatedOptions = benefit.options.filter((opt, index, self) => 
                      index === self.findIndex(o => o.optionNumber === opt.optionNumber)
                    );
                    return { ...benefit, options: deduplicatedOptions };
                  }
                  return benefit;
                });
                
                setUpdatedPolicyBenefits(cleanedBenefits);
              }
              
              props.showToast(`Successfully saved policy ${policyId}.`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
          }
      }

      setIsDirty(false);
      setSavingPolicy(false);
  }

  const checkIsDirty = () => {
      if (policyInfo) {
          if (policyInfo.policyName !== policyName || policyInfo.isPublished !== isPublished) {
              setIsDirty(true);
          } else {
              setIsDirty(false);
          }
      }
  }

  useEffect(() => {
      (async () => {
          const perDiemSelectionId = policyInfo?.savedBenefits ? policyInfo.savedBenefits.find((sb) => sb.benefitNumber === 3)?.options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
          const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;
          setHomefindingDays(numDaysBetweenFlights);

          if (destination && destination.city && destination.state) {
              setIsUpdatingSelections(true);

              const gsaResp = await getGsaPerDiem(destination.city, destination.state, '2025');
              const gsaDestinationCity = gsaResp.rates[0].rate[0].city;
              const gsaDestinationState = gsaResp.rates[0].state;

              const gsaNationalLodgingRate = await getNationalGsaLodgingPerDiem();
              const gsaNationalMealRate = await getNationalGsaMealPerDiem();

              let regionName = 'United States';
              if (gsaDestinationCity !== null && gsaDestinationState !== null) {
                regionName = `${gsaDestinationCity}, ${gsaDestinationState}`;
              }

              const homesalePriceResp = await props.getHomesalePriceByRegion(regionName);
              if (homesalePriceResp.response) {
                setAvgHomesalePrice(parseFloat(homesalePriceResp.response.averagePrice.replace(/[$,]+/g,"")));
              }

              // let currentDate = new Date();
              // let fullRate = gsaResp.rates[0].rate[0].months.month.find((rt) => rt.number === (currentDate.getMonth() + 1));
              setPerDiemMealRate(gsaNationalMealRate);
              setPerDiemRate(gsaNationalLodgingRate);

              if (origin && origin.city && origin.state) {
                const gsaOriginResp = await getGsaPerDiem(origin.city, origin.state, '2025');
                const gsaOriginCity = gsaOriginResp.rates[0].rate[0].city;
                const gsaOriginState = gsaOriginResp.rates[0].state;

                let originRegionName = 'United States';
                if (gsaOriginCity !== null && gsaOriginState !== null) {
                    originRegionName = `${gsaOriginCity}, ${gsaOriginState}`;
                }

                const homesalePriceOriginResp = await props.getHomesalePriceByRegion(originRegionName);
                if (homesalePriceOriginResp.response) {
                    setAvgHomesalePriceOrigin(parseFloat(homesalePriceOriginResp.response.averagePrice.replace(/[$,]+/g,"")));
                }

                let baseDate = new Date();
                baseDate.setDate(baseDate.getDate() + 14);
                const departureDate = baseDate.toISOString().split('T')[0];
                baseDate.setDate(baseDate.getDate() + numDaysBetweenFlights);
                const returnDate = baseDate.toISOString().split('T')[0];

                let newDistance = await getDistance(origin, destination);
                const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;

                const flightCostResp = await props.getFlightPrice({
                    departureCity: gsaOriginCity ? gsaOriginCity : origin.city,
                    departureState: gsaOriginState,
                    destinationCity: gsaDestinationCity ? gsaDestinationCity : destination.city,
                    destinationState: gsaDestinationState,
                    departureDate: departureDate,
                    returnDate: returnDate,
                    mileage: newParsedDistance,
                });

                if (flightCostResp.response && flightCostResp.response.price) {
                    setFlightCost(parseFloat(flightCostResp.response.price.total.replace(/[$,]+/g,"")));
                }

                setIsUpdatingSelections(false);
              } else {
                setIsUpdatingSelections(false);
              }
          }
      })();
  }, [destination, origin]);

  useEffect(() => {
      (async () => {
          if (origin && origin.formattedAddress && destination && destination.formattedAddress) {
              let newDistance = await getDistance(origin, destination);
              const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
              setDistance(newParsedDistance);

              if (newParsedDistance > 0) {
                const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                if (autoShipmentResp.response && autoShipmentResp.response.price) {
                    setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                }
              }

              setBenefits(getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance));
          }
      })();
  }, []);

  useEffect(() => {
    setBenefits(getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance));
  }, [perDiemRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost]);

  useEffect(() => {
      checkIsDirty();
  }, [policyName, isPublished]);

  const createdDate = policyInfo && policyInfo.createdDate ? new Date(policyInfo.createdDate) : new Date();
  const formattedCreated = `${createdDate.getFullYear()}-${((createdDate.getMonth() + 1) <= 9) ? ('0' + (createdDate.getMonth() + 1)) : createdDate.getMonth() + 1}-${(createdDate.getDate() <= 9) ? ('0' + createdDate.getDate()) : createdDate.getDate()}`;

  return (
      <div>
          <NavigationPrompt when={isDirty || isBenefitListDirty}> 
            {({ onConfirm, onCancel }) => {
                return (
                    <ConfirmModal
                        cancelText="Cancel"
                        confirmText="Confirm"
                        handleClose={() => { props.setBackButtonPath('/estimates'); onCancel(); }}
                        handleConfirm={onConfirm}
                        titleText="Unsaved Changes"
                        bodyText="You have unsaved changes on this cost estimate. Would you like to leave this page?"
                    />
                );
            }}
          </NavigationPrompt>

          <Box sx={{ position: 'fixed', zIndex: 4, backgroundColor: 'white', padding: '10px 0px 10px 10px', width: props.drawerOpen ? 'calc(100% - 240px)' : 'calc(100% - 60px)' }}>
              <Box>
                  <Grid container direction="row" >
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="name"
                                  className={classes.textField}
                                  label="Policy Name"
                                  value={policyName}
                                  variant="outlined"
                                  size="small"
                                  onChange={(e) => setPolicyName(e.target.value)}
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={1}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <FormControlLabel
                                  control={
                                      <Checkbox
                                          checked={isPublished}
                                          onChange={(e) => setIsPublished(e.target.checked)}
                                          color="primary"
                                      />
                                  }
                                  label="Is Published"
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box>
                              <GooglePlacesAutocompleteComponent
                                  initialValue={origin}
                                  value={origin != null ? (origin.formattedAddress ? origin.formattedAddress : origin) : ''}
                                  label={'Sample Origin'}
                                  onSelect={async (event, value) => {
                                      setOrigin(value);

                                      if (value && destination && destination.length !== 0) {
                                        // Distance is returned in meters so we need to divide by 1609 to get miles.
                                        let newDistance = await getDistance(value, destination);
                                        const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                                        setDistance(newParsedDistance);
                            
                                        if (newParsedDistance > 0) {
                                            const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                                            if (autoShipmentResp.response && autoShipmentResp.response.price) {
                                                setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                                            }
                                        }
                                      }
                                  }}
                                  onInputEdit={async (event) => {
                                      setOrigin(event);
                                  }}
                                  onInputClear={(event) => {
                                      setOrigin('');
                                  }}
                                  // onFocus={onFocus}
                                  // onBlur={onBlur}
                                  // disabled={disabled}
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box>
                              <GooglePlacesAutocompleteComponent
                                  initialValue={destination}
                                  value={destination != null ? (destination.formattedAddress ?  destination.formattedAddress : destination) : ''}
                                  label={'Sample Destination'}
                                  onSelect={async (event, value) => {
                                      setDestination(value);
                                      if (value && origin && origin.length !== 0) {
                                        // Distance is returned in meters so we need to divide by 1609 to get miles.
                                        let newDistance = await getDistance(origin, value);
                                        const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                                        setDistance(newParsedDistance);
                            
                                        if (newParsedDistance > 0) {
                                            const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                                            if (autoShipmentResp.response && autoShipmentResp.response.price) {
                                                setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                                            }
                                        }
                                      }
                                  }}
                                  onInputEdit={(event) => setDestination(event)}
                                  onInputClear={(event) => {
                                      setDestination('');
                                  }}
                                  size="small"
                                  // onFocus={onFocus}
                                  // onBlur={onBlur}
                                  // disabled={disabled}
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={1}>

                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '5px' }}>
                              <Typography color="primary">{policyId ? `Policy ${policyId}` : 'New Policy'}</Typography>
                              <Typography color="secondary">Move Miles: {distance}</Typography>
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="dateCreated"
                                  label="Date Created"
                                  type="date"
                                  value={formattedCreated}
                                  InputLabelProps={{
                                      shrink: true,
                                  }}
                                  InputProps={{
                                      className: classes.input,
                                  }}
                                  placeholder={'yyyy-mm-dd'}
                                  className={classes.textField}
                                  disabled={true}
                                  size="small"
                              />
                          </Box>
                      </Grid>
                  </Grid>
              </Box>
          </Box>

          <Box sx={{paddingTop: '100px', marginLeft: '10px', marginRight: '10px'}}>
              <BenefitSelections 
                isHeaderDirty={isDirty} 
                savingEstimate={savingPolicy} 
                reloPolicy={""} 
                distance={distance} 
                estimateInfo={policyInfo} 
                saveEstimate={savePolicy} 
                exportEstimate={null} 
                generateAuth={null} 
                benefits={benefits} 
                estimateId={null}
                policyId={policyId}
                isUpdatingSelections={isUpdatingSelections}
                isPremium={props.clientSettings ? props.clientSettings.isPremium : false}
                updatedPolicyBenefits={updatedPolicyBenefits}
                freeDownloadInfo={{
                    estimateInfo: {
                        origin: origin,
                        destination: destination,
                        distance: distance,
                        topLevelInputOneId: policyInfo ? policyInfo.topLevelInputOneId : null,
                        topLevelInputTwoId: policyInfo ? policyInfo.topLevelInputTwoId : null,
                        topLevelInputThreeId: policyInfo ? policyInfo.topLevelInputThreeId : null,
                        topLevelInputFourId: policyInfo ? policyInfo.topLevelInputFourId : null,
                    },
                    distance: distance,
                    perDiemRate: perDiemRate,
                    perDiemMealRate: perDiemMealRate,
                    avgHomesalePrice: avgHomesalePrice,
                    avgHomesalePriceOrigin: avgHomesalePriceOrigin,
                    flightCost: flightCost,
                    homefindingDays: homefindingDays,
                    autoShipmentCost: autoShipmentCost,
                }}
                setParentBenefitListDirty={setIsBenefitListDirty}
                lastDayHasPassed={false}
              />
          </Box>
      </div>
  );
}

const mapStateToProps = (state) => {
  return {
    policies: state.estimator.get('policies'),
    clientSettings: state.estimator.get('clientSettings'),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    setBackButtonPath,
    getHomesalePriceByRegion,
    getFlightPrice,
    getPolicies,
    postPolicy,
    updatePolicy,
    getAutoShipmentCost
  })(PolicyEditorPage),
);